module.exports = __webpack_public_path__ + "static/img/3529_phase_function_Paper_PointsHejduk_Prediction.65521f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3529_phase_function_Paper_PointsHejduk_Prediction.png
// module id = UpFy
// module chunks = 0